import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 26, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function TriangleMark({ className = "" }) {
  return <img src="/triangles.webp" alt="" aria-hidden="true" className={`w-auto ${className}`} />;
}

export function WeaveWordmark({ className = "" }) {
  return (
    <span className={`flex items-center gap-2.5 sm:gap-3 ${className}`}>
      <img src="/logo.webp" alt="The Weave" className="h-8 w-auto sm:h-10" />
      <span className="border-l border-paperborder pl-2.5 text-[11px] italic leading-tight text-body2 sm:pl-3 sm:text-xs">
        Experience,
        <br />
        rewoven
      </span>
    </span>
  );
}

export function ThreadDivider({ className = "" }) {
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1200 70" fill="none" preserveAspectRatio="none" className="h-12 w-full sm:h-16">
        <motion.path
          d="M0 35 C 220 12, 420 58, 640 35 S 1020 14, 1200 38"
          stroke="#4AA0A4"
          strokeWidth="2.5"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.8, ease: EASE }}
        />
        <motion.path
          d="M0 41 C 240 62, 460 18, 680 41 S 1040 60, 1200 30"
          stroke="#E93E36"
          strokeWidth="2"
          opacity="0.85"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.8, delay: 0.2, ease: EASE }}
        />
        <motion.path
          d="M0 29 C 260 6, 480 50, 700 27 S 1060 44, 1200 44"
          stroke="#F4B847"
          strokeWidth="2"
          opacity="0.8"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.8, delay: 0.35, ease: EASE }}
        />
      </svg>
    </div>
  );
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
